// src/pages/auth/SocialCallbackPage.jsx
import { useEffect, useRef } from 'react'
import { useParams, useNavigate, useSearchParams } from 'react-router-dom'
import { useAuth } from '@/context/AuthContext'
import { authApi } from '@/api/services'
import toast from 'react-hot-toast'

export default function SocialCallbackPage() {
  const { provider } = useParams()
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const { refreshUser } = useAuth()
  const called = useRef(false)

  useEffect(() => {
    if (called.current) return
    called.current = true

    const code = searchParams.get('code')
    if (!code) {
      toast.error('Authentication failed')
      navigate('/login', { replace: true })
      return
    }

    authApi.socialCallback(provider, code)
      .then(async (res) => {
        await refreshUser()
        const user = res.data?.user
        toast.success(`Welcome, ${user?.name?.split(' ')[0] || ''}!`)
        navigate(user?.role === 'admin' ? '/admin' : user?.role === 'supplier' ? '/supplier' : '/buyer', { replace: true })
      })
      .catch(() => {
        toast.error('Social login failed')
        navigate('/login', { replace: true })
      })
  }, [provider, searchParams, navigate, refreshUser])

  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-pink border-t-transparent rounded-full animate-spin mx-auto mb-3" />
        <p className="text-sm text-muted">Signing you in...</p>
      </div>
    </div>
  )
}
